var map = {
	"./CapitalFloat.png": 853,
	"./EarlySalary.png": 854,
	"./IndiaLends.png": 855,
	"./MoneyTap.png": 856,
	"./MoneyView.png": 857,
	"./NeoGrowth.svg": 858,
	"./PaySense.png": 859,
	"./Rupeek.svg": 860,
	"./SME_Corner.png": 861,
	"./StashFinLogo@2x.png": 862,
	"./UdaanCapital.png": 863,
	"./WishFin.png": 864,
	"./ZestMoney.png": 865,
	"./cred.png": 866,
	"./kredx.svg": 867,
	"./lendingKart.png": 868,
	"./progap.png": 869
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 852;